import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import DocumentsFormQuestion from 'modules/Documentation/DocumentsFormQuestion';
import { useTranslation } from 'react-i18next';
import { Radios, Field } from '@ontruck/orc';

const DynamicFormQuestion = ({
  className,
  field,
  handleFieldChange,
  carrierData,
  serverCarrierData,
  fieldsWithError,
}) => {
  const { t } = useTranslation('Documents');
  const fieldName = field?.label;
  const fieldType = field?.type;
  const serverValue = serverCarrierData?.extra_fields[fieldName];
  const formValue =
    carrierData.extra_fields && carrierData.extra_fields[fieldName];

  const checkDependencyToRender = useCallback(() => {
    if (!field?.dependency) return true;
    return Object.keys(field.dependency).every((item) =>
      item in carrierData
        ? carrierData[item] === field.dependency[item]
        : serverCarrierData[item] === field.dependency[item]
    );
  }, [field, serverCarrierData, carrierData]);

  const getRadioValue = useCallback(() => {
    if (carrierData.extra_fields && fieldName in carrierData.extra_fields)
      return formValue.toString();
    return fieldName in serverCarrierData.extra_fields
      ? serverValue.toString()
      : null;
  }, [carrierData, serverCarrierData, fieldName, formValue, serverValue]);

  const getTextValue = useCallback(() => serverValue || formValue, [
    formValue,
    serverValue,
  ]);

  if (!field || !checkDependencyToRender()) return null;

  return (
    <div className={className} data-testid="dynamic-form-question">
      <div className="dynamic-form-question">
        {fieldType === 'text' && (
          <DocumentsFormQuestion
            error={t(fieldName)}
            name={fieldName}
            fieldsWithError={fieldsWithError}
            serverCarrierData={serverCarrierData}
            extraClass="documents-form-question--extra-questions"
          >
            <Field
              onChange={(e, { name, value }) =>
                handleFieldChange('extra_fields', {
                  ...carrierData.extra_fields,
                  [fieldName]: value,
                })
              }
              name={fieldName}
              id={fieldName}
              label={t(fieldName)}
              size="M"
              labelType="regular"
              placeholder={t(`${fieldName}Placeholder`)}
              value={getTextValue(fieldName)}
              disabled={!!serverCarrierData?.extra_fields[fieldName]}
            />
          </DocumentsFormQuestion>
        )}
        {fieldType === 'radio' && (
          <DocumentsFormQuestion
            error={t(fieldName)}
            name={fieldName}
            fieldsWithError={fieldsWithError}
            serverCarrierData={serverCarrierData}
            extraClass="documents-form-question--extra-questions"
          >
            <Radios
              size="M"
              legend={t(fieldName)}
              name={fieldName}
              items={field.choices.map((choice) => ({
                label: t(choice.label),
                value: choice.value.toString(),
              }))}
              disabled={fieldName in serverCarrierData.extra_fields}
              value={getRadioValue(fieldName)}
              onChange={(e, { name, value }) => {
                handleFieldChange('extra_fields', {
                  ...carrierData.extra_fields,
                  [fieldName]: value === 'true',
                });
              }}
            />
          </DocumentsFormQuestion>
        )}
      </div>
    </div>
  );
};
DynamicFormQuestion.propTypes = {
  className: PropTypes.string,
};
export default DynamicFormQuestion;
